import { generateSourcesForPreloader } from 'src/pages/Home/components/AssetPreloader/assets/shared';
import {
  ImageMarqueeItemsOne,
  ImageMarqueeItemsThree,
  ImageMarqueeItemsTwo,
} from '../ReviewsHero/data';
import { PreloadLink } from '@farmersdog/tosa/src/components/shared/PreloadLink';

const PRELOADED_ITEMS_COUNT = 3;

export const AssetPreloader = () => {
  const preloadedItems = [
    ...ImageMarqueeItemsOne.slice(0, PRELOADED_ITEMS_COUNT),
    ...ImageMarqueeItemsTwo.slice(0, PRELOADED_ITEMS_COUNT),
    ...ImageMarqueeItemsThree.slice(0, PRELOADED_ITEMS_COUNT),
  ];

  const assetsForMarquees = preloadedItems.flatMap(item =>
    generateSourcesForPreloader({
      desktopSources: item.sources,
      mobileSources: item.sources,
    })
  );

  return <PreloadLink items={assetsForMarquees} />;
};
